// Circle @Figma
export const R0 = "50%";

// Contents area (dash board) @Figma
export const R1 = "10px";

// Modal @Figma
export const R2 = "15px";
// Modal Button @Figma
export const R3 = "8px";

// Button, Text box, Icon box @Figma
export const R4 = "6px";
// Category button @Figma
export const R5 = "30px";
